function Down({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0.506592L4.00001 4.49357L8 0.506592H0Z" fill=${`"${col}"`}/>
  </svg>
  `;

  return baseXml;
}

export default Down;
